export default (state, action) => {
  return Object.assign({}, state, { sort: action.sort });
};
